import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navigation() {
  const location = useLocation();

  return (
    <nav style={{
      display: 'flex',
      justifyContent: 'center',
      padding: '10px',
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      marginBottom: '20px',
      width: '100%'
    }}>
      <ul style={{
        display: 'flex',
        listStyle: 'none',
        margin: 0,
        padding: 0,
        gap: '20px'
      }}>
        <li>
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Home
          </Link>
        </li>
        <li>
          <Link 
            to="/editor" 
            className={`nav-link ${location.pathname === '/editor' ? 'active' : ''}`}
          >
            Document Editor
          </Link>
        </li>
        <li>
          <Link 
            to="/gendocx" 
            className={`nav-link ${location.pathname === '/gendocx' ? 'active' : ''}`}
          >
            Generate Word
          </Link>
        </li>
        <li>
          <Link 
            to="/survey-editor" 
            className={`nav-link ${location.pathname === '/survey-editor' ? 'active' : ''}`}
          >
            Survey Editor
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;